module.exports = __webpack_public_path__ + "img/light_bgBox_bg.47996a4f.png";